import React from "react";
import { Link } from "react-router-dom";
import PDFIcon from "../Images/pdfIcon.png";

const Notice = () => {
  const certificates = [
    {
      link: "Notice-of-BM-06052024.pdf",
      title: "Notice of BM 06052024",
    },
    {
      link: "Notice-of-BM-04062024.pdf",
      title: "Notice of BM 04062024",
    },
    {
      link: "Notice-of-BM-10082024.pdf",
      title: "Notice of BM 10082024",
    },
    {
      link: "Notice-of-BM-19122024.pdf",
      title: "Notice of BM 19122024",
    },
    {
      link: "Notice-of-BM-31122024.pdf",
      title: "Notice of BM 31122024",
    },
    {
      link: "Notice-of-BM-27012025.pdf",
      title: "Notice of BM 27012025",
    },
    {
      link: "Notice-of-BM-05022025.pdf",
      title: "Notice of BM 05022025",
    },
    {
      link: "Notice-of-BM-19022025.pdf",
      title: "Notice of BM 19022025",
    },
    {
      link: "Notice-of-BM-27022025.pdf",
      title: "Notice of BM 27022025",
    },
  ];

  const downloadFile = (event, status) => {
    event.preventDefault();

    if (status) {
      const formattedUrl = `https://essexmpl.com/Pdf/Notice/${status}`;
      window.open(formattedUrl, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div className="py-80">
      <div className="container">
        <div className="row">
          {certificates.map((certificate, id) => (
            <div className="col-md-6 col-lg-4" key={id}>
              <div className="team-item">
                <Link
                  to={"#"}
                  onClick={(e) => downloadFile(e, certificate.link)}
                  target="_blank"
                >
                  <img src={PDFIcon} alt="thumb" />
                  <div className="team-content">
                    <div className="team-bio">
                      <h5>
                        <a href="team.html">{certificate.title}</a>
                      </h5>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Notice;
